// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-message[data-v-0a0dfdd8]{padding:var(--space-88) var(--space-48)}.error-message p[data-v-0a0dfdd8]{color:var(--grey);font-size:var(--font-size-18);text-align:center;margin-bottom:0}", ""]);
// Exports
module.exports = exports;
